import { render, staticRenderFns } from "./consignment.vue?vue&type=template&id=a67c1d30&scoped=true&"
import script from "./consignment.vue?vue&type=script&lang=js&"
export * from "./consignment.vue?vue&type=script&lang=js&"
import style0 from "./consignment.vue?vue&type=style&index=0&id=a67c1d30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a67c1d30",
  null
  
)

export default component.exports